
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { GroupModel, PlanItemModel, ProcessTypeEnum, TenantUserModel } from '@/libs/Api';
import DashboardCardView from '@/libs/dashboard/components/DashboardCardView.vue';
import { planItemsStore } from '@/libs/plan-items/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { groupsStore } from '@/libs/groups/+state/store';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import IssueSolvingItemSmall from '@/libs/issues-solving/components/IssueSolvingItemSmall.vue';
import moment from 'moment/moment';

@Component({
    components: {
        IssueSolvingItemSmall,
        DashboardCardView,
    },
})
export default class DashboardTodayMaintenance extends Page {
    @Prop() tenantId!: string;
    protected tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    protected ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;

    get items(): PlanItemModel[] {
        return [...planItemsStore.useGetter(CrudGetter.DataBasic, 'DashboardMaintenance')] ?? [];
    }

    mounted() {
        this.loadSolvingList();
    }

    loadSolvingList() {
        const groups: GroupModel[] = groupsStore.useGetter(CrudGetter.Data) ?? [];
        const myGroupIds = groups
            .filter((x) => x.groupUsers?.some((n) => n.tenantUserId == this.tenantUser.id))
            .map((x) => x.id!);
        planItemsStore.dispatch(
            CrudAction.GetAllBasic,
            createCrudQueryPayload(
                { field: 'time', index: 1, order: 'desc' },
                [
                    {
                        field: 'isDeactivated',
                        op: 'eq',
                        comparand: false,
                    },
                    { field: 'processType', op: 'eq', comparand: ProcessTypeEnum.Maintenance },
                    { field: 'time', op: 'gte', comparand: moment().startOf('day').toDate() },
                    { field: 'time', op: 'lte', comparand: moment().endOf('day').toDate() },
                    { field: 'isAnswered', op: 'eq', comparand: false },
                    { field: 'planItemAuditTenantUsers.tenantUserId', op: 'eq', comparand: this.tenantUser.id! },
                ],
                {
                    pageIndex: 1,
                    pageSize: 8,
                },
                false,
                'DashboardMaintenance'
            )
        );
    }
}
